/**
 * Google OAuth — Create React App (not Vite).
 * Env at build time: process.env.REACT_APP_GOOGLE_CLIENT_ID
 * Runtime fallback: public/config.js + index.html (see getRuntimeGoogleClientId).
 */

function pickNonEmpty(...values) {
  for (const v of values) {
    const s = v != null ? String(v).trim() : "";
    if (!s) continue;
    if (s.includes("%REACT_APP_") && s.includes("%")) continue;
    return s;
  }
  return "";
}

/** Set in index.html at build time when REACT_APP_GOOGLE_CLIENT_ID is defined. */
export function getRuntimeGoogleClientId() {
  if (typeof window === "undefined") return "";
  return pickNonEmpty(window.__CHINTAMAT_CONFIG__?.googleClientId);
}

export function getGoogleClientId() {
  return pickNonEmpty(
    getRuntimeGoogleClientId(),
    process.env.REACT_APP_GOOGLE_CLIENT_ID,
  );
}

export function isGoogleAuthConfigured() {
  return Boolean(getGoogleClientId());
}

export function buildGoogleAuthUrl() {
  const clientId = getGoogleClientId();
  if (!clientId || typeof window === "undefined") return null;
  const redirectUri = `${window.location.origin}/auth/callback`;
  const params = new URLSearchParams({
    client_id: clientId,
    redirect_uri: redirectUri,
    response_type: "code",
    scope: "openid email profile",
    access_type: "online",
    prompt: "select_account",
  });
  return `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
}
